export const workflowTaskType = {
  Manual: 1,
  AutomatedDocument: 2,
  AutomatedEmail: 3
}

export const WORKFLOW_TASK_TYPE_OPTIONS = [
  { id: workflowTaskType.Manual, name: 'Manual' },
  { id: workflowTaskType.AutomatedDocument, name: 'Automated - Document' },
  { id: workflowTaskType.AutomatedEmail, name: 'Automated - Email' }
]

export const workflowEmailRecipientSource = {
  Candidate: 1,
  Consultant: 2,
  Custom: 3
}

export const WORKFLOW_EMAIL_RECIPIENT_SOURCE_OPTIONS = [
  { id: workflowEmailRecipientSource.Candidate, name: 'Candidate' },
  { id: workflowEmailRecipientSource.Consultant, name: 'Consultant' },
  { id: workflowEmailRecipientSource.Custom, name: 'Custom' }
]

export const workflowEmailReviewStatus = {
  PendingInternalReview: 1,
  ApprovedAndSent: 2,
  Rejected: 3
}

export const WORKFLOW_EMAIL_REVIEW_STATUS_OPTIONS = [
  { id: workflowEmailReviewStatus.PendingInternalReview, name: 'Pending Internal Review' },
  { id: workflowEmailReviewStatus.ApprovedAndSent, name: 'Approved & Sent' },
  { id: workflowEmailReviewStatus.Rejected, name: 'Rejected' }
]
